// DEPRECATED: consolidated into invariantAggregators.js — kept for backward compat
// ─────────────────────────────────────────────────────────────────────────────
// IndustryAggregator.js
// Personal care industry background questions: news sources, product use,
// credibility, awareness, PCPC familiarity, industry favorability,
// legislative support, and favorability change after message exposure.
// ─────────────────────────────────────────────────────────────────────────────

// Deck-harmonised categorical ramp (cool to warm, matches report palette)
export const DISTINCT = [
  "#1E3A5F", // dark navy
  "#2D6A9F", // mid-blue
  "#5B8DB8", // light blue
  "#1A7A78", // teal
  "#4AA8A6", // light teal
  "#8C9BA5", // slate-gray
  "#B0BEC5", // light gray
  "#E8722A", // orange
  "#F4955E", // light orange
  "#C45A1E", // burnt orange
];

export function getIndustryColours() {
  return DISTINCT;
}

export function getIndustryConfig() {
  const groupsById = {

  

    // buy: {
    //   type: "categorical",
    //   label: "How often buy personal care products",
    //   fulltext: "How often do you buy cosmetic or personal care products?",
    //   keys: [
    //     "buy__weekly_pred_n",
    //     "buy__2_3_weeks_pred_n",
    //     "buy__monthly_pred_n",
    //     "buy__2_3_months_pred_n",
    //     "buy__3_6_months_pred_n",
    //     "buy__few_times_pred_n",
    //   ],
    //   labels: {
    //     "buy__weekly_pred_n":       "At least weekly",
    //     "buy__2_3_weeks_pred_n":    "Every 2-3 weeks",
    //     "buy__monthly_pred_n":      "Once a month",
    //     "buy__2_3_months_pred_n":   "Every 2-3 months",
    //     "buy__3_6_months_pred_n":   "Every 3-6 months",
    //     "buy__few_times_pred_n":    "A few times a year or less",
    //   },
    //   colors: {
    //     "buy__weekly_pred_n":       "#1A7A78", // teal
    //     "buy__2_3_weeks_pred_n":    "#2D6A9F", // mid-blue
    //     "buy__monthly_pred_n":      "#8C9BA5", // slate-gray
    //     "buy__2_3_months_pred_n":   "#E8722A", // orange
    //     "buy__3_6_months_pred_n":   "#1E3A5F", // navy
    //     "buy__few_times_pred_n":    "#C45A1E", // burnt orange
    //   },
    //   schema: "single",
    // },


    industry_posneg: {
      type: "likert",
      label: "Industry favorability",
      fulltext: "Do you feel positively or negatively towards the cosmetics and personal care products industry?",
      keys: [
        "ind_favorability__pos_pred_n",
        "ind_favorability__neg_pred_n",
        "ind_favorability__neither_pred_n",
        "ind_favorability__dk_pred_n",
      ],
      labels: {
        "ind_favorability__pos_pred_n":     "Positively",
        "ind_favorability__neg_pred_n":     "Negatively",
        "ind_favorability__neither_pred_n": "Neither",
        "ind_favorability__dk_pred_n":      "Don't know",
      },
      polarity: {
        pos: "ind_favorability__pos_pred_n",
        neg: "ind_favorability__neg_pred_n",
        neu: "ind_favorability__neither_pred_n",
      },
      schema: "single",
    },
    pcpc_familiar: {
      type: "likert",
      label: "Familiarity with PCPC",
      fulltext: "How familiar are you with the following companies?",
      keys: [
        "pcpc_fam__very_pred_n",
        "pcpc_fam__moderately_pred_n",
        "pcpc_fam__slightly_pred_n",
        "pcpc_fam__heard_pred_n",
        "pcpc_fam__not_heard_pred_n",
      ],
      labels: {
        "pcpc_fam__very_pred_n":       "Very familiar",
        "pcpc_fam__moderately_pred_n": "Moderately familiar",
        "pcpc_fam__slightly_pred_n":   "Slightly familiar",
        "pcpc_fam__heard_pred_n":      "Heard of but know nothing",
        "pcpc_fam__not_heard_pred_n":  "Never heard of them",
      },
      polarity: {
        pos: [
          "pcpc_fam__very_pred_n",
          "pcpc_fam__moderately_pred_n",
          "pcpc_fam__slightly_pred_n",
        ],
        neu: ["pcpc_fam__heard_pred_n"],
        neg: ["pcpc_fam__not_heard_pred_n"],
      },
      colors: {
        "pcpc_fam__very_pred_n":       "#1A7A78",
        "pcpc_fam__moderately_pred_n": "#4AA8A6",
        "pcpc_fam__slightly_pred_n":   "#A8D5D4",
        "pcpc_fam__heard_pred_n":      "#8C9BA5",
        "pcpc_fam__not_heard_pred_n":  "#C0392B",
      },
      schema: "single",
    },
    leg_support: {
      type: "likert",
      label: "Support for state legislation on personal care products",
      fulltext: "Do you support or oppose states introducing legislation to regulate personal care products?",
      keys: [
        "leg_support__support_pred_n",
        "leg_support__neither_pred_n",
        "leg_support__oppose_pred_n",
        "leg_support__dk_pred_n",
      ],
      labels: {
        "leg_support__support_pred_n": "Support",
        "leg_support__neither_pred_n": "Neither",
        "leg_support__oppose_pred_n":  "Oppose",
        "leg_support__dk_pred_n":      "Don't know",
      },
      polarity: {
        pos: "leg_support__support_pred_n",
        neg: "leg_support__oppose_pred_n",
        neu: "leg_support__neither_pred_n",
      },
      schema: "single",
    },

    buy_approach: {
      type: "categorical",
      label: "Typical buying approach",
      fulltext: "When you're buying a personal care or cosmetic product, which of the following best describes your typical approach?",
      keys: [
        "buy_app__research_pred_n",
        "buy_app__reviews_pred_n",
        "buy_app__brands_pred_n",
        "buy_app__price_pred_n",
        "buy_app__no_thought_pred_n",
      ],
      labels: {
        "buy_app__research_pred_n":  "I carefully research ingredients and reviews before buying",
        "buy_app__reviews_pred_n":   "I look at reviews or recommendations, but don’t spend much time",
        "buy_app__brands_pred_n":    "I usually stick to brands I like",
        "buy_app__price_pred_n":     "I decide based on price or what’s available",
        "buy_app__no_thought_pred_n":"I don’t put much thought into it",
      },
      colors: {
        "buy_app__research_pred_n":  "#1A7A78", // teal
        "buy_app__reviews_pred_n":   "#2D6A9F", // mid-blue
        "buy_app__brands_pred_n":    "#1E3A5F", // navy
        "buy_app__price_pred_n":     "#E8722A", // orange
        "buy_app__no_thought_pred_n":"#8C9BA5", // slate-gray
      },
      schema: "single",
    },

    use: {
      type: "likert",
      label: "Product use vs. average American",
      fulltext: "Would you say you use more or fewer products than the average American?",
      keys: [
        "use__far_more_pred_n",
        "use__more_pred_n",
        "use__about_average_pred_n",
        "use__less_pred_n",
        "use__far_less_pred_n",
        "use__dk_pred_n",
      ],
      labels: {
        "use__far_more_pred_n":      "Far more than average",
        "use__more_pred_n":          "More than average",
        "use__about_average_pred_n": "About average",
        "use__less_pred_n":          "Less than average",
        "use__far_less_pred_n":      "Far less than average",
        "use__dk_pred_n":            "Don't know",
      },
      polarity: {
        pos: ["use__far_more_pred_n", "use__more_pred_n"],
        neu: ["use__about_average_pred_n", "use__dk_pred_n"],
        neg: ["use__less_pred_n", "use__far_less_pred_n"],
      },
      // colors: {
      //   "use__far_more_pred_n":      "#1A7A78", // deep teal
      //   "use__more_pred_n":          "#4AA8A6", // light teal
      //   "use__about_average_pred_n": "#8C9BA5", // slate-gray (neutral)
      //   "use__less_pred_n":          "#E8835E", // light red-orange
      //   "use__far_less_pred_n":      "#C0392B", // deep red
      //   "use__dk_pred_n":            "#B0BEC5", // pale gray
      // },
      schema: "single",
    },

    information: {
      type: "categorical",
      label: "Most credible information source",
      fulltext: "When it comes to information about personal care and cosmetics products, which of the following do you find the most credible?",
      keys: [
        "info__derm_pred_n",
        "info__ped_pred_n",
        "info__doctor_pred_n",
        "info__ind_research_pred_n",
        "info__scientist_pred_n",
        "info__pub_expert_pred_n",
        "info__reg_pred_n",
        "info__official_pred_n",
        "info__pcindustry_pred_n",
        "info__brands_pred_n",
        "info__advocacy_pred_n",
        "info__environ_pred_n",
        "info__small_biz_pred_n",
        "info__local_biz_pred_n",
        "info__parents_pred_n",
        "info__influencer_pred_n",
        // "info__dk_none_pred_n",
      ],
      labels: {
        "info__derm_pred_n":         "Dermatologists",
        "info__ped_pred_n":          "Pediatricians",
        "info__doctor_pred_n":       "Doctors / physicians",
        "info__ind_research_pred_n": "Independent academic researchers",
        "info__scientist_pred_n":    "Industry scientists",
        "info__pub_expert_pred_n":   "Public health experts",
        "info__reg_pred_n":          "Health & safety regulators (FDA)",
        "info__official_pred_n":     "Elected officials",
        "info__pcindustry_pred_n":   "Cosmetics & personal care industry",
        "info__brands_pred_n":       "Corporate brands",
        "info__advocacy_pred_n":     "Consumer advocacy organizations",
        "info__environ_pred_n":      "Environmental groups",
        "info__small_biz_pred_n":    "Small business owners",
        "info__local_biz_pred_n":    "Local business groups / chambers of commerce",
        "info__parents_pred_n":      "Parents",
        "info__influencer_pred_n":   "Social media influencers",
        // "info__dk_none_pred_n": "None",
      },
      schema: "single",
    },

    info_source: {
      type: "categorical",
      label: "Hear about new products",
      fulltext: "Where do you typically hear about new personal care or cosmetic products?",
      keys: [
        "info_source__social_pred_n",
        "info_source__friends_pred_n",
        "info_source__derm_pred_n",
        "info_source__online_pred_n",
        "info_source__instore_pred_n",
        "info_source__advert_pred_n",
        "info_source__website_pred_n",
        "info_source__outreach_pred_n",
        "info_source__other_pred_n",
      ],
      labels: {
        "info_source__social_pred_n":    "Social media",
        "info_source__friends_pred_n":   "Friends and family",
        "info_source__derm_pred_n":      "Dermatologists / healthcare professionals",
        "info_source__online_pred_n":    "Online reviews or blogs",
        "info_source__instore_pred_n":   "In-store / at point of sale",
        "info_source__advert_pred_n":    "TV or online advertisement",
        "info_source__website_pred_n":   "Brand websites",
        "info_source__outreach_pred_n":  "Direct outreach from brands",
        "info_source__other_pred_n":     "Other",
      },
      schema: "single",
    },

    awareness: {
      type: "categorical",
      label: "Awareness of industry news stories",
      fulltext: "Which of the following, if any, have you heard about?",
      keys: [
        "awareness__bans_restrictions_pred_n",
        "awareness__trace_limits_pred_n",
        "awareness__chemical_restrictions_pred_n",
        "awareness__age_restricts_pred_n",
        "awareness__labelling_require_pred_n",
        "awareness__pack_recycle_pred_n",
        "awareness__state_regs_pred_n",
        "awareness__not_heard_pred_n",
      ],
      labels: {
        "awareness__bans_restrictions_pred_n":     "Bans on specific ingredients",
        "awareness__trace_limits_pred_n":          "Limits on trace chemical impurities",
        "awareness__chemical_restrictions_pred_n": "PFAS / class-based restrictions",
        "awareness__age_restricts_pred_n":         "Age-based sales restrictions",
        "awareness__labelling_require_pred_n":     "New labeling / warning requirements",
        "awareness__pack_recycle_pred_n":          "Packaging & recycling mandates",
        "awareness__state_regs_pred_n":            "State cosmetic safety regulations",
        "awareness__not_heard_pred_n":             "Not heard of any",
      },
      schema: "single",
    },

    news_source: {
      type: "categorical",
      label: "Main source of news",
      fulltext: "What is your main source of news?",
      keys: [
        "news_source__tv_pred_n",
        "news_source__newspaper_pred_n",
        "news_source__radio_pred_n",
        "news_source__social_pred_n",
        "news_source__friends_pred_n",
        "news_source__podcast_pred_n",
        "news_source__other_pred_n",
      ],
      labels: {
        "news_source__tv_pred_n":        "Television",
        "news_source__newspaper_pred_n": "Newspapers / news websites",
        "news_source__radio_pred_n":     "Radio",
        "news_source__social_pred_n":    "Social media",
        "news_source__friends_pred_n":   "Friends and family",
        "news_source__podcast_pred_n":   "Podcasts",
        "news_source__other_pred_n":     "Other",
      },
      schema: "single",
    },

  };

  return { groupsById };
}

export function buildIndustryLabelColorMaps(groupsById) {
  const labels  = {};
  const colors  = {};
  let colorIdx  = 0;

  for (const g of Object.values(groupsById)) {
    for (const k of g.keys) {
      labels[k] = g.labels?.[k] || k;

      if (!colors[k]) {
        if (g.colors?.[k]) {
          colors[k] = g.colors[k];
        } else if (g.type === "likert") {
          colors[k] = baseColorForLikertKey(g, k);
        } else {
          colors[k] = DISTINCT[colorIdx % DISTINCT.length];
          colorIdx += 1;
        }
      }
    }
  }

  return { labels, colors };
}

export function aggregateWeighted(rows, keys, { rowKey, weight = "total", predicate = null } = {}) {
  const acc  = Object.create(null);
  const zero = Object.fromEntries(keys.map(k => [k, 0]));

  for (const r of rows || []) {
    if (predicate && !predicate(r)) continue;
    const d = r[rowKey];
    if (!d) continue;
    const w = Number(r[weight] ?? 0);
    if (!acc[d]) acc[d] = { w: 0, sums: { ...zero } };
    acc[d].w += w;
    for (const k of keys) acc[d].sums[k] += Number(r[k] ?? 0) * w;
  }

  const out = {};
  for (const [d, { w, sums }] of Object.entries(acc)) {
    const values = {};
    for (const k of keys) values[k] = w > 0 ? (sums[k] / w) * 100 : 0;
    out[d] = { totalWeight: w, values };
  }
  return out;
}

export function buildDemoPredicate({
  gender    = null,
  age       = null,
  ethnicity = null,
  party     = null,
  education = null,
} = {}) {
  return (r) => {
    if (gender    != null && Number(r.gender)    !== Number(gender))    return false;
    if (age       != null && Number(r.age)       !== Number(age))       return false;
    if (ethnicity != null && Number(r.ethnicity) !== Number(ethnicity)) return false;
    if (party     != null && Number(r.party_reg) !== Number(party))     return false;
    if (education != null && Number(r.education) !== Number(education)) return false;
    return true;
  };
}

export const GENDER = [
  { value: null, label: "All" },
  { value: 1,    label: "Men" },
  { value: 2,    label: "Women" },
];

export const AGE = [
  { value: null, label: "All" },
  { value: 1,    label: "18–34" },
  { value: 2,    label: "35–64" },
  { value: 3,    label: "65+" },
];

export const ETHNICITY = [
  { value: null, label: "All" },
  { value: 1,    label: "White" },
  { value: 2,    label: "Black" },
  { value: 3,    label: "Hispanic" },
  { value: 4,    label: "Asian" },
  { value: 5,    label: "Other" },
];

export const PARTY = [
  { value: null, label: "All" },
  { value: 1,    label: "Dem" },
  { value: 2,    label: "Rep" },
  { value: 3,    label: "Ind" },
  { value: 4,    label: "None" },
];

export const EDU = [
  { value: null, label: "All" },
  { value: 1,    label: "No degree" },
  { value: 2,    label: "Degree" },
];

export function baseColorForLikertKey(group, key) {
  const pol = group?.polarity || {};
  const tag = Object.entries(pol).find(([_, polKey]) => {
    if (Array.isArray(polKey)) return polKey.includes(key);
    return polKey === key;
  })?.[0];
  if (tag === "pos") return "#1A7A78";
  if (tag === "neg") return "#C0392B";
  if (tag === "neu") return "#8C9BA5";
  return "#607D8B";
}

// Tab-as-config default export
export default {
  tab: "invariant_industry",
  label: "Invariant Industry",
  get metrics() { return getIndustryConfig().groupsById; },
};
